<template>
  <q-page padding class=" window-width row justify-center items-center">
    <div class="col-12 col-sm-8">
      <div v-if="false" class="text-center">
        <q-circular-progress
            indeterminate
            rounded
            size="50px"
            color="primary"
            class="q-ma-md"
        />
      </div>
      <div v-else-if="!error" class="text-center">
        <h6 class="text-positive">Аккаунт успешно подтвержден</h6>
        <q-btn
            no-caps
            flat
            to="/login"
            label="Войти"
            color="primary"
        />
      </div>
    </div>
  </q-page>
</template>

<script setup lang="ts">
import {VerifyRequest} from "../models/auth";
import {useVerify} from "../composables/auth";
import {useRoute} from "vue-router"

const route = useRoute()
const request: VerifyRequest = {
  code: route.params.code as string,
  username: route.query.username as string
}

const {isFetching, error} = useVerify(request)
</script>

<style scoped>

</style>